import { createSlice } from "@reduxjs/toolkit"
import { 
  fetchChannelLatestDataForDashboard,
  fetchChartsInfoForDashboards, 
  fetchLiveTrendDataForDashboard,
  fetchLiveTrendLatestDataForDashboard,
  fulfilledFetchChannelLatestDataForDashboard,
  fulfilledFetchChartsInfoForDashboards,
  fulfilledFetchLiveTrendDataForDashboard,
  fulfilledFetchLiveTrendLatestDataForDashboard,
  pendingFetchLiveTrendDataForDashboard,
  pendingFetchLiveTrendLatestDataForDashboard,
  rejectedFetchLiveTrendDataForDashboard,
  rejectedFetchLiveTrendLatestDataForDashboard,
} from "../async/customDashboardAsync";
import Actions from "../action/customDashboardsAction";


const initialState = {
  channelLatestDataForDashboard: [],
  charts: {},
  dashboardLiveTrendData: [],
  dashboardLiveTrendLatestData: [],
  isDashboardLiveTrendFetching: [],
  dashboardLiveTrendChannelNos: [],
  isOpenLiveTrendEditPage: false,
}

const customDashboardSlice = createSlice({
  name: 'customDashboard',
  initialState,
  reducers: {
    ...Actions
  },
  extraReducers: (builder) => {
    builder.addCase(fetchChannelLatestDataForDashboard.fulfilled, fulfilledFetchChannelLatestDataForDashboard)
    builder.addCase(fetchChartsInfoForDashboards.fulfilled, fulfilledFetchChartsInfoForDashboards)
    builder.addCase(fetchLiveTrendDataForDashboard.fulfilled, fulfilledFetchLiveTrendDataForDashboard)
    builder.addCase(fetchLiveTrendLatestDataForDashboard.fulfilled, fulfilledFetchLiveTrendLatestDataForDashboard)
    builder.addCase(fetchLiveTrendDataForDashboard.pending, pendingFetchLiveTrendDataForDashboard)
    builder.addCase(fetchLiveTrendLatestDataForDashboard.pending, pendingFetchLiveTrendLatestDataForDashboard)
    builder.addCase(fetchLiveTrendDataForDashboard.rejected, rejectedFetchLiveTrendDataForDashboard)
    builder.addCase(fetchLiveTrendLatestDataForDashboard.rejected, rejectedFetchLiveTrendLatestDataForDashboard)
  }
})

// selector
export const getChannelLatestDataForDashboard = (state) => state.customDashboardController.channelLatestDataForDashboard;
export const getDashboardCharts = (state) => state.customDashboardController.charts
export const getDashboardLiveTrendData = (state) => state.customDashboardController.dashboardLiveTrendData;
export const getDashboardLiveTrendLatestData = (state) => state.customDashboardController.dashboardLiveTrendLatestData;
export const getIsDashboardLiveTrendFetching = (state) => state.customDashboardController.isDashboardLiveTrendFetching;
export const getDashboardLiveTrendChannelNos = (state) => state.customDashboardController.dashboardLiveTrendChannelNos;
export const isOpenLiveTrendEditPage = (state) => state.customDashboardController.isOpenLiveTrendEditPage;

export const {
  setDashboardLiveTrendChannelNos,
  setIsOpenLiveTrendEditPage,
  setIsDashboardLiveTrendFetching,
} = customDashboardSlice.actions;

export default customDashboardSlice.reducer;